import React, { useEffect, useState } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import Axios from 'axios';
import { API_HOST, axiosRequestWithAuth, REMEMBER_ME_TOKEN } from '../../constants/server.constant';
import SessionService from '../../services/session.service';
import useDidMount from '../../hooks/useDidMount';
import { userService } from '../../services/user.service';
import { loginService } from '../../services/login.service';


const PrivateRoute = ({ component: Component, ...rest }) => {
    const isFirstRender = useDidMount();
    const [isVerified, setIsVerified] = useState("");
    const [isRefreshing, setIsRefreshing] = useState(true);
    const [redirect, setRedirect] = useState(`/login`);
    const history = useHistory();

    //let navigateToPage = "/login" 
    // let isVerified = SessionService.getCookie("isLoggedIn") && SessionService.getCookie("is2faVerified") === 'Y';
    // if (localStorage.getItem("_email_verify")) {
    //     isVerified = undefined;
    // }

    useEffect(() => {
        if(!localStorage.getItem("_email_verify")) {
            setIsVerified(SessionService.getCookie("isLoggedIn") && SessionService.getCookie("is2faVerified") === 'Y');
        } else {
            setRedirect(`/email-confirmation`);
            setIsRefreshing(false);
        }
    }, []);

    useEffect(() => {
        if(!isFirstRender) {
            if(!isVerified) {
                if(SessionService.getCookie(REMEMBER_ME_TOKEN)) {
                    Axios.get(API_HOST + "/login/authenticate/refresh", axiosRequestWithAuth).then(resp => {
                        // console.log("New session established with refresh token");
                        if(resp?.data?.redirect) {
                            history.push(resp.data.redirect);
                        }
                        userService.getUserData().then(resp => {
                            setIsVerified(true);
                            setIsRefreshing(false);
                        }).catch(err => {
                            loginService.redirectToLogin();
                        });
                    }).catch(error => {
                        // console.log("Unable to establish previous session: " + error?.response?.status);
                        setIsRefreshing(false);
                    });
                } else {
                    setIsRefreshing(false);
                }
            } else {
                // console.log("Verified ...");
                setIsRefreshing(false);
            }
        }
    }, [isVerified]);

    if(isRefreshing) {
        return null;
    } else {
        if(isVerified) {
            loginService.deleteCookie("_redirect_url", "/app");
        }
        return <Route { ...rest } render={ props => (
            isVerified ?
                <Component { ...props } i18n={ rest.i18n } />
                : <Redirect to={ { pathname: redirect, state: { fromPrivateRoute: true } } } />
        ) }
        />;
    }
};

export default PrivateRoute;